import ApiService from '@appServices/apiService';

class UserService extends ApiService {
    async getPermissions() {
        return this.fetchWithHeaders('/api/user', 'GET').then((response) => {
            if (window.posthog && response?.user?.client?.reference) {
                // We register clientRef as a super property that will be included in every captured events
                window.posthog.register({
                    clientRef: response.user.client.reference,
                });
            }
            return response;
        });
    }

    async getCurrentUser() {
        return this.fetchWithHeaders('/api/v2/me', 'GET');
    }

    async setLanguage(languageCode) {
        return this.fetchWithHeaders('/api/v2/user/language', 'POST', {
            body: JSON.stringify({ language: languageCode }),
        });
    }
}

export default UserService;
